<template>
	<div class="navbar-item has-dropdown " :class="{ 'is-active': opened }">
		<a class="navbar-link has-text-primary " @click="open">
			<Icon family="fal" name="fa-flag" />
		</a>

		<div class="navbar-dropdown is-right">
			<a
				class="navbar-item has-text-primary mr-2"
				:class="{ 'is-active': isActive(lang) }"
				v-for="(lang, i) in langs"
				:key="`Lang${i}`"
				:value="lang"
				@click="select(lang)"
			>
				{{ $t(`languages.${lang}`) }}
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: "language-selector",
	data() {
		return {
			langs: ["es", "en"],
			opened: false,
		};
	},
	methods: {
		open() {
			if (this.opened) {
				this.opened = false;
			} else {
				this.opened = true;
			}
		},
		close() {
			this.opened = false;
		},
		select(lang) {
			this.$i18n.locale = lang;
			this.close();
		},
		isActive(lang) {
			return this.$i18n.locale === lang;
		},
	},
};
</script>